/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { Configuration } from '../configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiModelsGatewaysGet } from '../fn/models/api-models-gateways-get';
import { ApiModelsGatewaysGet$Params } from '../fn/models/api-models-gateways-get';
import { apiModelsHierarchyGet } from '../fn/models/api-models-hierarchy-get';
import { ApiModelsHierarchyGet$Params } from '../fn/models/api-models-hierarchy-get';
import { apiModelsLlmTestPreparePost } from '../fn/models/api-models-llm-test-prepare-post';
import { ApiModelsLlmTestPreparePost$Params } from '../fn/models/api-models-llm-test-prepare-post';
import { apiModelsLlmTestStartPost } from '../fn/models/api-models-llm-test-start-post';
import { ApiModelsLlmTestStartPost$Params } from '../fn/models/api-models-llm-test-start-post';
import { apiModelsSttTestPost } from '../fn/models/api-models-stt-test-post';
import { ApiModelsSttTestPost$Params } from '../fn/models/api-models-stt-test-post';
import { apiModelsTtsTestPost } from '../fn/models/api-models-tts-test-post';
import { ApiModelsTtsTestPost$Params } from '../fn/models/api-models-tts-test-post';
import { apiModelsTypesGet } from '../fn/models/api-models-types-get';
import { ApiModelsTypesGet$Params } from '../fn/models/api-models-types-get';
import { apiModelsVersionsModelVersionIdGet } from '../fn/models/api-models-versions-model-version-id-get';
import { ApiModelsVersionsModelVersionIdGet$Params } from '../fn/models/api-models-versions-model-version-id-get';
import { apiModelsVersionsModelVersionIdVoicesGet } from '../fn/models/api-models-versions-model-version-id-voices-get';
import { ApiModelsVersionsModelVersionIdVoicesGet$Params } from '../fn/models/api-models-versions-model-version-id-voices-get';
import { GetGatewaysResult } from '../models/get-gateways-result';
import { GetModelsHierarchyResult } from '../models/get-models-hierarchy-result';
import { GetModelTypesResult } from '../models/get-model-types-result';
import { GetVoicesByModelVersionResult } from '../models/get-voices-by-model-version-result';
import { ModelVersionFullDto } from '../models/model-version-full-dto';
import { PrepareLlmTestResult } from '../models/prepare-llm-test-result';
import { StartLlmTestResult } from '../models/start-llm-test-result';
import { TestSttResult } from '../models/test-stt-result';
import { TestTtsAudioResult } from '../models/test-tts-audio-result';


/**
 * Available models (STT, TTS, LLM, VAD)
 */
@Injectable({ providedIn: 'root' })
export class ModelsService extends BaseService {
  constructor(config: Configuration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiModelsHierarchyGet()` */
  static readonly ApiModelsHierarchyGetPath = '/api/Models/hierarchy';

  /**
   * Каталог моделей. По дефолту возвращает только версии с
   * `IsRecommended=true` (cascading — модели/gateway/типы без
   * оставшихся версий скрываются). Для админки —
   * `?includeAll=true` возвращает полный sync.
   *             
   * Публичный (AllowAnonymous): для анонимного пользователя коэф'ы
   * берутся из дефолтного плана (`GetLago:DefaultPlanCode`).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiModelsHierarchyGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiModelsHierarchyGet$Response(params?: ApiModelsHierarchyGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetModelsHierarchyResult>> {
    const obs = apiModelsHierarchyGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Каталог моделей. По дефолту возвращает только версии с
   * `IsRecommended=true` (cascading — модели/gateway/типы без
   * оставшихся версий скрываются). Для админки —
   * `?includeAll=true` возвращает полный sync.
   *             
   * Публичный (AllowAnonymous): для анонимного пользователя коэф'ы
   * берутся из дефолтного плана (`GetLago:DefaultPlanCode`).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiModelsHierarchyGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiModelsHierarchyGet(params?: ApiModelsHierarchyGet$Params, context?: HttpContext): Observable<GetModelsHierarchyResult> {
    const resp = this.apiModelsHierarchyGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetModelsHierarchyResult>): GetModelsHierarchyResult => r.body)
    );
  }

  /** Path part for operation `apiModelsVersionsModelVersionIdGet()` */
  static readonly ApiModelsVersionsModelVersionIdGetPath = '/api/Models/versions/{modelVersionId}';

  /**
   * Полная версия модели вместе с `AdditionalProperties` на всех
   * уровнях (ModelType + Model + ModelVersion). В общей иерархии эти
   * схемы не отдаются (слишком тяжело) — фронт вызывает эту ручку когда
   * пользователь выбрал конкретную версию и нужно отрисовать её параметры.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiModelsVersionsModelVersionIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiModelsVersionsModelVersionIdGet$Response(params: ApiModelsVersionsModelVersionIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelVersionFullDto>> {
    const obs = apiModelsVersionsModelVersionIdGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Полная версия модели вместе с `AdditionalProperties` на всех
   * уровнях (ModelType + Model + ModelVersion). В общей иерархии эти
   * схемы не отдаются (слишком тяжело) — фронт вызывает эту ручку когда
   * пользователь выбрал конкретную версию и нужно отрисовать её параметры.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiModelsVersionsModelVersionIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiModelsVersionsModelVersionIdGet(params: ApiModelsVersionsModelVersionIdGet$Params, context?: HttpContext): Observable<ModelVersionFullDto> {
    const resp = this.apiModelsVersionsModelVersionIdGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ModelVersionFullDto>): ModelVersionFullDto => r.body)
    );
  }

  /** Path part for operation `apiModelsTypesGet()` */
  static readonly ApiModelsTypesGetPath = '/api/Models/types';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiModelsTypesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiModelsTypesGet$Response(params?: ApiModelsTypesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetModelTypesResult>> {
    const obs = apiModelsTypesGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiModelsTypesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiModelsTypesGet(params?: ApiModelsTypesGet$Params, context?: HttpContext): Observable<GetModelTypesResult> {
    const resp = this.apiModelsTypesGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetModelTypesResult>): GetModelTypesResult => r.body)
    );
  }

  /** Path part for operation `apiModelsGatewaysGet()` */
  static readonly ApiModelsGatewaysGetPath = '/api/Models/gateways';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiModelsGatewaysGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiModelsGatewaysGet$Response(params?: ApiModelsGatewaysGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetGatewaysResult>> {
    const obs = apiModelsGatewaysGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiModelsGatewaysGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiModelsGatewaysGet(params?: ApiModelsGatewaysGet$Params, context?: HttpContext): Observable<GetGatewaysResult> {
    const resp = this.apiModelsGatewaysGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetGatewaysResult>): GetGatewaysResult => r.body)
    );
  }

  /** Path part for operation `apiModelsVersionsModelVersionIdVoicesGet()` */
  static readonly ApiModelsVersionsModelVersionIdVoicesGetPath = '/api/Models/versions/{modelVersionId}/voices';

  /**
   * Активные TTS-голоса под конкретной версией модели. Возвращает только
   * IsActive=true. Используется фронтом после выбора (Author × Model × Version)
   * для рендера списка голосов с preview.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiModelsVersionsModelVersionIdVoicesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiModelsVersionsModelVersionIdVoicesGet$Response(params: ApiModelsVersionsModelVersionIdVoicesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetVoicesByModelVersionResult>> {
    const obs = apiModelsVersionsModelVersionIdVoicesGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Активные TTS-голоса под конкретной версией модели. Возвращает только
   * IsActive=true. Используется фронтом после выбора (Author × Model × Version)
   * для рендера списка голосов с preview.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiModelsVersionsModelVersionIdVoicesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiModelsVersionsModelVersionIdVoicesGet(params: ApiModelsVersionsModelVersionIdVoicesGet$Params, context?: HttpContext): Observable<GetVoicesByModelVersionResult> {
    const resp = this.apiModelsVersionsModelVersionIdVoicesGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetVoicesByModelVersionResult>): GetVoicesByModelVersionResult => r.body)
    );
  }

  /** Path part for operation `apiModelsTtsTestPost()` */
  static readonly ApiModelsTtsTestPostPath = '/api/Models/tts/test';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiModelsTtsTestPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiModelsTtsTestPost$Response(params?: ApiModelsTtsTestPost$Params, context?: HttpContext): Observable<StrictHttpResponse<TestTtsAudioResult>> {
    const obs = apiModelsTtsTestPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiModelsTtsTestPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiModelsTtsTestPost(params?: ApiModelsTtsTestPost$Params, context?: HttpContext): Observable<TestTtsAudioResult> {
    const resp = this.apiModelsTtsTestPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TestTtsAudioResult>): TestTtsAudioResult => r.body)
    );
  }

  /** Path part for operation `apiModelsSttTestPost()` */
  static readonly ApiModelsSttTestPostPath = '/api/Models/stt/test';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiModelsSttTestPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiModelsSttTestPost$Response(params?: ApiModelsSttTestPost$Params, context?: HttpContext): Observable<StrictHttpResponse<TestSttResult>> {
    const obs = apiModelsSttTestPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiModelsSttTestPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiModelsSttTestPost(params?: ApiModelsSttTestPost$Params, context?: HttpContext): Observable<TestSttResult> {
    const resp = this.apiModelsSttTestPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TestSttResult>): TestSttResult => r.body)
    );
  }

  /** Path part for operation `apiModelsLlmTestPreparePost()` */
  static readonly ApiModelsLlmTestPreparePostPath = '/api/Models/llm/test/prepare';

  /**
   * Шаг 1: получаем streamId. Фронт подписывается на SignalR-события
   * (LlmStreamChunk/LlmStreamCompleted/LlmStreamFailed) с этим streamId,
   * и только потом вызывает /llm/test/start.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiModelsLlmTestPreparePost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiModelsLlmTestPreparePost$Response(params?: ApiModelsLlmTestPreparePost$Params, context?: HttpContext): Observable<StrictHttpResponse<PrepareLlmTestResult>> {
    const obs = apiModelsLlmTestPreparePost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Шаг 1: получаем streamId. Фронт подписывается на SignalR-события
   * (LlmStreamChunk/LlmStreamCompleted/LlmStreamFailed) с этим streamId,
   * и только потом вызывает /llm/test/start.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiModelsLlmTestPreparePost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiModelsLlmTestPreparePost(params?: ApiModelsLlmTestPreparePost$Params, context?: HttpContext): Observable<PrepareLlmTestResult> {
    const resp = this.apiModelsLlmTestPreparePost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PrepareLlmTestResult>): PrepareLlmTestResult => r.body)
    );
  }

  /** Path part for operation `apiModelsLlmTestStartPost()` */
  static readonly ApiModelsLlmTestStartPostPath = '/api/Models/llm/test/start';

  /**
   * Шаг 2: запускаем стриминг. HTTP-ответ возвращается после завершения стрима
   * (с финальным текстом и usage). Чанки приходят через SignalR.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiModelsLlmTestStartPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiModelsLlmTestStartPost$Response(params?: ApiModelsLlmTestStartPost$Params, context?: HttpContext): Observable<StrictHttpResponse<StartLlmTestResult>> {
    const obs = apiModelsLlmTestStartPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Шаг 2: запускаем стриминг. HTTP-ответ возвращается после завершения стрима
   * (с финальным текстом и usage). Чанки приходят через SignalR.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiModelsLlmTestStartPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiModelsLlmTestStartPost(params?: ApiModelsLlmTestStartPost$Params, context?: HttpContext): Observable<StartLlmTestResult> {
    const resp = this.apiModelsLlmTestStartPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<StartLlmTestResult>): StartLlmTestResult => r.body)
    );
  }

}
